export default __webpack_public_path__ + "static/bmw-1-fea8ae125485d600029fa98e9a0b0c52.jpg";